var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Item"},[_c('headerItemDv1',{attrs:{"msg":"月申请数量趋势图"}}),_c('div',{staticClass:"grid-container"},[_c('div',{ref:"chart",staticClass:"flex-1 charts-style",staticStyle:{"width":"100%","height":"440px"},attrs:{"id":"chart"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }